import { Link } from "react-router-dom";
import EntryCard from "@/components/feature/EntryCard";
import { entries } from "@/mocks/entries";

export default function HotEntries() {
  const list = entries.slice(0, 6);

  return (
    <section className="w-full border-b border-background-200 bg-background-50 px-4 py-14 md:px-10 md:py-20">
      <div className="mb-10 flex flex-col gap-4 md:mb-14 md:flex-row md:items-end md:justify-between">
        <div className="max-w-2xl">
          <span className="font-heading text-sm font-bold tracking-[0.2em] text-primary-600">
            HOT ENTRIES
          </span>
          <h2 className="mt-3 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl">
            本周热度最高的瓜条
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">
            按阅读量与讨论度排序，收录最近仍在更新的词条。每一条都附带完整时间线与各方回应。
          </p>
        </div>
        <Link
          to="/entries"
          className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          浏览全部词条
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((entry) => (
          <EntryCard key={entry.slug} entry={entry} />
        ))}
      </div>
    </section>
  );
}